.ui-panel {
  position: relative;
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  background: linear-gradient(145deg, rgba(13, 27, 42, 0.94), rgba(7, 17, 29, 0.98));
  box-shadow:
    0 18px 50px rgba(0, 0, 0, 0.24),
    inset 0 1px rgba(255, 255, 255, 0.025);
  overflow: hidden;
}

.ui-panel::before {
  content: '';
  position: absolute;
  inset: 0 auto auto 0;
  width: 44%;
  height: 1px;
  background: linear-gradient(90deg, var(--cyan), transparent);
  opacity: 0.46;
}

.ui-panel-header {
  min-height: 64px;
  padding: 18px 20px 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.ui-panel-header h2 {
  margin: 2px 0 0;
  font: 650 1rem/1.2 var(--font-display);
  letter-spacing: -0.01em;
}

.ui-eyebrow {
  color: var(--muted);
  font-size: 0.66rem;
  font-weight: 760;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.ui-status,
.ui-synthetic {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  width: fit-content;
  border: 1px solid var(--line-strong);
  border-radius: 999px;
  padding: 4px 8px;
  font-size: 0.64rem;
  font-weight: 760;
  letter-spacing: 0.07em;
  line-height: 1;
  text-transform: uppercase;
  white-space: nowrap;
}

.ui-status--cyan {
  color: var(--cyan);
  background: var(--cyan-soft);
  border-color: rgba(52, 213, 255, 0.3);
}
.ui-status--amber {
  color: var(--amber);
  background: var(--amber-soft);
  border-color: rgba(245, 184, 77, 0.32);
}
.ui-status--red {
  color: var(--red);
  background: var(--red-soft);
  border-color: rgba(255, 91, 108, 0.32);
}
.ui-status--green {
  color: var(--green);
  background: var(--green-soft);
  border-color: rgba(70, 224, 163, 0.28);
}
.ui-status--violet {
  color: var(--violet);
  background: rgba(171, 142, 255, 0.1);
  border-color: rgba(171, 142, 255, 0.3);
}
.ui-status--neutral {
  color: var(--muted-strong);
  background: rgba(255, 255, 255, 0.03);
}

.ui-synthetic {
  color: var(--cyan);
  background: rgba(52, 213, 255, 0.08);
  border-color: rgba(52, 213, 255, 0.2);
}

.ui-synthetic--compact {
  font-size: 0.57rem;
  padding: 3px 6px;
}

.ui-provenance--live-local {
  color: #7ee7bf;
  border-color: rgba(73, 207, 156, 0.35);
  background: rgba(35, 133, 99, 0.12);
}

.ui-provenance--seeded {
  color: #8cc9ff;
  border-color: rgba(73, 160, 228, 0.35);
  background: rgba(39, 103, 156, 0.12);
}

.ui-avatar {
  display: inline-grid;
  place-items: center;
  width: 38px;
  height: 38px;
  flex: 0 0 auto;
  border: 1px solid rgba(52, 213, 255, 0.44);
  border-radius: 13px;
  color: var(--cyan);
  background: linear-gradient(145deg, rgba(52, 213, 255, 0.14), rgba(52, 213, 255, 0.03));
  font: 720 0.68rem/1 var(--font-display);
  box-shadow: 0 0 0 3px rgba(52, 213, 255, 0.035);
}

.ui-avatar.is-compact {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  font-size: 0.58rem;
}
.ui-avatar--waiting_human {
  border-color: rgba(245, 184, 77, 0.62);
  color: var(--amber);
}
.ui-avatar--blocked {
  border-color: rgba(255, 91, 108, 0.72);
  color: var(--red);
}
.ui-avatar--qa_review {
  border-color: rgba(70, 224, 163, 0.65);
  color: var(--green);
}
.ui-avatar--offline {
  border-color: var(--line-strong);
  color: var(--muted);
  filter: saturate(0.2);
}

.ui-metric {
  min-width: 0;
  padding: 15px 16px;
  border-right: 1px solid var(--line);
}

.ui-metric:last-child {
  border-right: 0;
}
.ui-metric > span {
  display: block;
  color: var(--muted);
  font-size: 0.69rem;
  font-weight: 680;
  letter-spacing: 0.04em;
}
.ui-metric strong {
  display: block;
  margin-top: 6px;
  font: 650 1.5rem/1 var(--font-display);
  letter-spacing: -0.04em;
}
.ui-metric small {
  display: block;
  margin-top: 5px;
  color: var(--muted);
  font-size: 0.63rem;
}
